export const MAIN_CLASS_NAME = 'folders-page';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const TOOLBAR_CLASS_NAME = `${CONTENT_CLASS_NAME}__toolbar`;
export const NAME_CELL_CLASS_NAME = `${CONTENT_CLASS_NAME}__name-cell`;
export const ID_CELL_CLASS_NAME = `${CONTENT_CLASS_NAME}__id-cell`;
export const COPY_BUTTON_CLASS_NAME = `${ID_CELL_CLASS_NAME}__copy-button`;
export const PAGINATION_CLASS_NAME = `${MAIN_CLASS_NAME}__pagination`;

export const FOLDERS_PAGE_SIZE = 30;
export const TOOLTIP_MOUSE_DELAY = 0.5;

export const TRANSLATION_GROUP_PREFIX = 'Folders: Page:';
